import React from "react";
import ListeSignalementsTable from "../Signalements/ListeSignalementsTable";
import { TiExport } from "react-icons/ti";
import { useExportXls } from "../../../../utils/hooks/useExportXls";

const Signalements = () => {
	const handleExport = useExportXls("export_signalements", "signalements.xls");

	return (
		<div className="dashboard-admin-component">
			<div className="container-dashboard-page bg-white p-3">
				<div className="admin-page-title-header-container flex-sb align-items-center">
					<h4 className="crypta-dash-header-titre">Signalements</h4>
					<div className="content-btn-add-theme">
						<button className="btn btn-export-csv" onClick={handleExport}>
							<TiExport style={{ color: "#08BB90", fontSize: 20 }} />
							<span className="ps-2">Export EN Xls</span>
						</button>
					</div>
				</div>
				<div className="col-left-dashboard col-left-dashboard-responsive mb-3">
					<ListeSignalementsTable />
				</div>
			</div>
		</div>
	);
};

export default Signalements;